import { useState, useEffect, useMemo } from 'react';
import { useLanguage } from '../../i18n';

interface LoadingOverlayProps {
  isLoading: boolean;
}

function LoadingOverlay({ isLoading }: LoadingOverlayProps) {
  const { lang, t } = useLanguage();
  const [loadingQuoteIndex, setLoadingQuoteIndex] = useState(0);

  const quotes = useMemo(() => t.loadingQuotes, [t.loadingQuotes]);

  useEffect(() => {
    if (isLoading && quotes.length > 0) {
      // 로딩 시작시 랜덤으로 시작
      setLoadingQuoteIndex(Math.floor(Math.random() * quotes.length));

      // 3초마다 다음 명언으로 변경
      const interval = setInterval(() => {
        setLoadingQuoteIndex((prev) => (prev + 1) % quotes.length);
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [isLoading, quotes.length]);

  if (!isLoading) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center"
      data-testid="evaluating-overlay"
    >
      <div className="flex flex-col items-center gap-6 px-4">
        <div className="w-16 h-16 border-4 border-status-go/30 border-t-status-go rounded-full animate-spin"></div>
        <div className="text-terminal-text text-lg font-mono">
          {t.form.evaluating}
          <span className="cursor-blink"></span>
        </div>
        <div className="text-terminal-muted text-sm text-center">
          {lang === 'ko'
            ? 'AI가 릴리즈 준비 상태를 분석하고 있습니다...'
            : 'AI is analyzing release readiness...'}
        </div>
        {quotes.length > 0 && (
          <div className="mt-4 p-4 bg-terminal-card/50 rounded-lg border border-terminal-border/30 whitespace-nowrap">
            <div
              className="text-terminal-accent text-sm text-center italic animate-fade-in"
              key={loadingQuoteIndex}
            >
              {quotes[loadingQuoteIndex]}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoadingOverlay;

